import React, { Component } from "react";
import { connect } from "react-redux";
import Store from "../../content/Store";
import Content from "../../content/Content";
import TelephoneNumberRequired from "../../components/shared/TelephoneNumberRequired";
import MemberHelper from "../../helpers/MemberHelper";
import { withRouter, Link } from "react-router-dom";
import { Paths } from "../../constants/UrlConstants";
import InfoBox from "../../components/shared/InfoBox";
import commonStyles from "../../assets/css/modules/myprofile/change-profile-common.css";
import ChangePhoneNumberLine from "./ChangePhoneNumberLine";

export const mapStateToProps = ({ policyReducer = {} }) => {
  const selectedPolicy = policyReducer.selectedPolicy;
  const policyDetails = policyReducer.policyDetails;
  const currentMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    selectedPolicy
  );

  return {
    MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    NoOfPolicies:
      (policyDetails &&
        Array.isArray(policyDetails.Policies) &&
        policyDetails.Policies.length) ||
      0,
    MemberPhone: currentMember.PhoneNumbers,
    IsFormat2: selectedPolicy && selectedPolicy.IsFormat2,
    disabled: policyDetails && policyDetails.IsInternalView
  };
};

class ChangePhoneNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      singleEditMode: false
    };
    if (!this.props.IsFormat2) {
      this.props.history.replace(Paths.MyProfile);
    }
  }

  render() {
    return (
      <div className={commonStyles.changeProfile}>
        <h1 className="axa-headline">
          <Content name={Store.ChangePhoneNumber.Title} />
        </h1>
        {this.props.NoOfPolicies > 1 ? (
          <div id="infoBox" className={commonStyles.infoBox}>
            <InfoBox iconClass={"icon-functional-help"}>
              <Content
                name={Store.ChangeProfileCommon.InfoBox}
                params={{
                  MembershipNumber: this.props.MembershipNumber
                }}
              />
            </InfoBox>
          </div>
        ) : null}
        <TelephoneNumberRequired isTelephoneNumberRequired>
          <div id="memberPhone">
            {Array.isArray(this.props.MemberPhone) &&
              this.props.MemberPhone.map((telephone, index) => (
                <ChangePhoneNumberLine
                  disabled={this.props.disabled}
                  key={index}
                  Telephone={telephone}
                  DisableEdit={this.state.singleEditMode}
                  HandleEdit={() => {
                    this.setState({
                      singleEditMode: true
                    });
                  }}
                  CallBackParent={() => {
                    this.setState({
                      singleEditMode: false
                    });
                  }}
                />
              ))}
          </div>
        </TelephoneNumberRequired>
              {window?.axa?.features?.MFAFeature === "true" && <div>
                <strong>
                {Store.ChangePhoneNumber.MFA.MFATitle}
                </strong>
                <br />
                {Store.ChangePhoneNumber.MFA.MFAText}
              </div>}
        <div className={commonStyles.actionButtons}>
          <div className="col-sm-6 back-button">
            <Link to={Paths.MyProfile}>
              <span className="mr-2 left-arrow-back">←</span>{" "}
              <Content name={Store.ChangeProfileCommon.BackButtonLabel} />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(ChangePhoneNumber));
